import React, {useState} from 'react';


const ContinueButton = () => {


    const [buttonText, setButtonText] = useState("Sign up successful, logging you in...");

    const handleClick = async () =>{
        setButtonText("Please wait...");

    };
    return (
        <button
            className={`bg-gold-accent text-base lg:text-xl hover:bg-gold-accent-hover h-14 px-1 md:px-4 py-2 rounded-lg w-full  justify-self-center cursor-pointer`}
            onClick={handleClick}
            disabled={buttonText === "Please wait..."}
        >
            {buttonText}
        </button>
    );
};

export default ContinueButton;